module.exports = __webpack_public_path__ + "media/images/hotel-towels-rolled-in-wooden-basket-dec08493eefa5aa0f045fd634ec37371.jpg";